<template>
  <div class="jumbotron opening">
    <h1 v-if="title" class="display-4 title-font">{{title}}</h1>
    <hr class="my-4">
    <p v-if="buttons" class="button-container lead">
      <button v-for="(navButton, index) in buttons"
        :key="index"
        class="btn btn-primary btn-lg title-font-light"
        @click="clickedNavButton(navButton.label)"
      >
        <font-awesome-icon :icon="navButton.icon" class="icon"/>
        <a :href="`#${navButton.refName}`" role="button">{{navButton.label}}</a>
      </button>
    </p>
  </div>
</template>

<script>
import {sendGoogleAnalyticsEvent} from "@/helpers/utils";

export default {
  name: "JumbotronNav",
  props: {
    title: { type: String, required: false },
    buttons: { type: Array, required: false },
  },
  methods: {
    clickedNavButton(buttonName) {
      const pageName = this.$route.name;
      sendGoogleAnalyticsEvent(`Clicked Nav Button (${pageName} page)`, 'generate_lead', buttonName);
    },
  }
}
</script>

<style scoped>
.jumbotron {
  background: none;
  padding: 4rem 2rem;
  margin-bottom: 2rem;
}

.btn {
  margin-right: 1rem;
  margin-bottom: 1rem;
  width: fit-content;
}

.btn a {
  color: #FFFFFF;
  /*Makes whole button clickable instead of just link text*/
  display: inline-block;
  position: relative;
  max-height: 4rem;
  padding: 0.5rem 5vw;
  margin: -0.5rem -5vw;
  z-index: 1;
}

.icon {
  margin-right: 1rem;
}

@media screen and (max-width: 900px) {
  .btn {
    position: relative;
    width: 100%;
  }
  .jumbotron {
    padding: 1rem 0 0 0;
  }
}
</style>